/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 2:41 PM
 *
 */
import { useQuery } from 'react-query';

import { getNestedMemberList } from '../requests/member.request';

export const useNestedMemberList = (
  roleId: number,
  parentId: number,
  memberId?: number,
  pageNumber = 1,
  enabled?: boolean,
  filterParams?: string,
  searchTerms?: string
) => {
  return useQuery(
    ['member-list-nested', roleId, parentId, pageNumber, filterParams, searchTerms],
    () => getNestedMemberList(roleId, parentId, pageNumber, filterParams, searchTerms),
    {
      enabled: roleId !== 0 && enabled && !isNaN(roleId),
      refetchOnWindowFocus: true,
    }
  );
};
